<template lang="pug">
  v-layout.box-comprobante-desktop-formatter(column)
    //- LOADER PROCESS
    v-dialog(v-model="loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Descargando...
          v-progress-linear.mb-0(indeterminate="" color="white")
    v-flex
      span Elige el mes que deseas descargar tu&nbsp;
        b Comprobante
    v-flex.box-elements
      v-layout(column align-center)
        v-flex(
          style="margin: 0.3em;display: flex;align-items: center;"
          v-for="(item, index) in listaDeComprobantes" :key="index"
          )
          TarjetaFechaDescarga(
            @downloadMethod="downloadComprobanteElectronico(item.tipoDocumento, item.serie, item.correlativo, item.historico)"
            style="width: 17em ;height: 3.2em; cursor:pointer"
            :textProp="item.fechaEmision"
            :iconDescarga="iconDescarga")
    //- v-flex(style="text-align: center;" v-if="poliza.nombreProducto !== 'VIDACASH'")
      span(style="line-height: normal;color: #454A6C;font-size: 14px;") Si deseas descargar tus comprobantes anteriores
        br
        span al 2019, solicítalo por nuestro&nbsp;
        a(:href="links.Chat" target="_blank")
          b chat web
</template>

<script>
import * as d3 from 'd3'
import { mapActions } from 'vuex'
import TarjetaFechaDescarga from './../generic/TarjetaFechaDescarga.vue'

export default {
  props: [
    'listaDeComprobantes',
    'iconDescarga',
    'poliza',
    'taggeo'
  ],
  data () {
    return {
      loader: false,
      comprobantesFormatter: []
    }
  },
  mounted () {
    let self = this

    self.metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Comprobante electrónico', metadata: self.metadata})

    d3.select('.box-comprobante-desktop-formatter')
      .style('opacity', '0')
      .transition().duration(300)
      .style('opacity', '1')

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'desktop',
        'seccion': 'ce'
      }
    })

    self.comprobantesFormatter = self.listaDeComprobantes.reverse()
  },
  methods: {
    ...mapActions('user', ['downloadComprobante', 'downloadComprobanteLegacy']),
    ...mapActions('event', ['eventLog']),
    downloadComprobanteElectronico (tipoComprobante, serie, numero, esHistorico) {
      const self = this

      this.loader = true
      let hash = {
        tipoDocumento: tipoComprobante,
        serie: serie,
        correlativo: numero,
        producto: this.poliza.oriProducto || this.poliza.producto,
        grupoProducto: this.poliza.ramo.toUpperCase(),
        numeroPoliza: this.poliza.numeroPoliza
      }
      // TRACK EVENT - GA
      /*
      this.$gtm.trackEvent({
        event: 'Descargas Comprobantes Elec.',
        category: 'Zona Privada',
        action: 'ComprobantesElectronicos',
        label: 'Descarga de Comprobantes Electrónicos'
      })
      */
      // TRACK EVENT - AMPLITUDE
      /* var productoConsultado = ''
      if (this.poliza.oriProducto === null) {
        if (this.poliza.modalidad === null) {
          productoConsultado = this.poliza.producto
        } else {
          productoConsultado = this.poliza.modalidad
        }
      } else {
        productoConsultado = this.poliza.oriProducto
      }
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Comprobantes Electrónicos',
            'Producto Consultado': productoConsultado,
            'Meses consultados': [this.ce.startDate.split('-')[1], this.ce.endDate.split('-')[1]]
          }
        ) */
      const callbackEventLog = (omitEvent) => {
        if (!omitEvent) {
          this.eventLog({
            categoria: 'Documentos',
            nombre: 'Descarga Comprobantes/Boletas',
            datos: hash
          })
        }
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: 'Descarga de Comprobante',
            metadata: self.metadata
          })
        }, 3000)
      }
      if (esHistorico) {
        hash.Tipo = 'histórico'
        let xml = {
          tipoDoc: serie,
          folio: numero
        }
        this.downloadComprobanteLegacy(xml)
          .then(res => {
            self.loader = false
            hash.Estado = 'Exitoso'
            hash.respuesta = res.data
            callbackEventLog()
          })
          .catch((err) => {
            hash.error = err.response.data
            hash.statusCode = err.response.status
            self.loader = false
            callbackEventLog()
          })
      } else {
        this.downloadComprobante(hash)
          .then((res) => {
            self.loader = false
            callbackEventLog(true)
          })
          .catch((err) => {
            self.loader = false
            if (err.data.codigoRespuesta === '99') {
              self.$swal({
                title: 'Estimado cliente',
                text: 'El Comprobante de Pago Electrónico ' + numero + ' , especificado no está registrado o no se encuentra en estado ACEPTADO.',
                confirmButtonText: 'Entendido'
              })
            } else {
              callbackEventLog(true)
            }
          })
      }
    }
  },
  components: {
    TarjetaFechaDescarga
  }

}
</script>

<style scoped>
.box-comprobante-desktop-formatter {
  margin: 2em auto;
  width: 23rem;
}

.box-comprobante-desktop-formatter span,
.box-comprobante-desktop-formatter a {
  color: var(--text-color);
}

.box-comprobante-desktop-formatter .box-elements {
  margin: 2em 0em;
  min-height: 14em;
  max-height: 18.7em;
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/ComprobanteElectronicoDesktop.vue